import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {compose, graphql, Mutation, Query} from "react-apollo";
import ReactDOM from 'react-dom';
import TextareaAutosize from "react-textarea-autosize";
import {Col, DropdownItem, FormGroup, Row} from "reactstrap";
import Loading from "../../components/Loading";
import {Button, Input} from "reactstrap";
import gql from "graphql-tag";
import FindAddress from "../../components/FindAddress";

const GET_ZIP_CODES = gql`
    query findPostalCodeByMPRN($mprn:[String]) {
        findPostalCodeByMPRN(mprn: $mprn) {
            block
            city
            county
            dependentCity
            dependentStreet
            doubleDependentCity
            houseNumber
            houseNumberAdd
            mpan
            mprn
            postalCode
            street
            ldz
            gas_meter_serial_number
        }
    }
`;

const START_NOMINATION = gql`
    mutation startBulkNomination($addresses:[com_methodia_salesportal_domain_AddressResource_AddressInput], $annualQuantity: Float ) {
        startBulkNomination(addresses: $addresses, annualQuantity: $annualQuantity)
    }
`;

class BulkNomination extends Component {

    constructor(props) {
        super(props);
        this.handleAddressChoice = this.handleAddressChoice.bind(this);
        this.handlePostalCodeClick = this.handlePostalCodeClick.bind(this);
        this.state = {value: "", step: "enter-meter-points"};
    }

    componentWillReceiveProps(nextProps) {

    }

    loadZipCodes() {
        console.log(this.state.value)
    }

    handlePostalCodeChange(mprn) {
        return function (e) {
            let res = {...this.state.result}
            res[mprn].address.postalCode = e.target.value;
            this.setState({result: res})
            console.log(this.state.result)
        }.bind(this)
    }

    handlePostalCodeClick(mprn) {
        return function (e) {
            let res = {...this.state.result}
            if (!res[mprn].showAddress) {
                for (const key in res) {
                    res[key].showAddress = false;
                }
            }

            res[mprn].showAddress = !res[mprn].showAddress;
            console.log(res);
            this.setState({result: res})
        }.bind(this)
    }

    handleAddressChoice(mprn) {
        return function (address) {
            if (Object.keys(address).length === 0) return;
            //delete(address.mprn);
            let value = this.state.value;
            let result = {...this.state.result};
            result[mprn] = {skip: false, mprn: mprn, showAddress: true, address: address};
            this.setState({result: result, value: value, step: "show-zip-codes"})
            console.log(this.state)
        }.bind(this)
    }

    render() {
        const mprns = this.state.value.trim().split('\n');
        switch (this.state.step) {
            case "enter-meter-points" :
                return (<div>
                        <Row className='step'>
                            <Col className='col-xl-1 col-lg-2 col-md-3 col-sm-1'/>
                            <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-10 step-header'>
                                <h2>Meter Points</h2></Col>
                        </Row>
                        <Row className='step'>
                            <Col className='col-xl-1 col-lg-2 col-md-3 col-sm-1'/>
                            <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-10 step-header'>
                                <Input type="select" name="select" id="exampleSelect"
                                       onChange={e => this.setState({annualQuantity: e.target.value})}
                                       className='col-xl-8 col-lg-8 col-md-10 col-sm-12'>
                                    <option>--- Please select ---</option>
                                    <option value="75000">Nomination Process</option>
                                    <option value="50000">Nomination Enquery</option>
                                </Input>
                            </Col>
                        </Row>
                        <Row className='step'>
                            <Col className='col-xl-1 col-lg-2 col-md-3 col-sm-1'/>
                            <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-10 step-body'>
                                <TextareaAutosize
                                    minRows={20}
                                    className='col-xl-8 col-lg-8 col-md-10 col-sm-12'
                                    placeholder="Insert Meter Points each on new line..."
                                    onChange={e => this.setState({value: e.target.value})}
                                /></Col></Row>
                        <Row className='step'>
                            <Col className='col-xl-1 col-lg-2 col-md-3 col-sm-1'/>
                            <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-10 step-header'>
                                <Button onClick={() =>
                                    this.setState({step: "load-zip-codes"})
                                }>Start</Button>
                            </Col>
                        </Row>
                    </div>
                )
                break;


            case "load-zip-codes" :
                console.log("load-zip-codes")
                return (<Query query={GET_ZIP_CODES} variables={{mprn: mprns}}>
                    {({loading, error, data}) => {
                        if (loading) return (<Loading/>);
                        if (error) return `Error! ${error.message}`;

                        this.state.result = {}
                        mprns.forEach((e) => this.state.result[e] = {mprn: e, skip: true, address: {}})

                        if (data.findPostalCodeByMPRN) data.findPostalCodeByMPRN.map(record =>
                            this.state.result[record.mprn] = {
                                address: record,
                                skip: !record.postalCode,
                                showAddress: !record.postalCode,
                                mprn: record.mprn
                            }
                        )
                        this.setState({step: "show-zip-codes"})
                        return null;
                    }}
                </Query>);
                break;

            case "show-zip-codes":
                return <div>
                    <Row className='step'>
                        <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-12 step-header offset-xl-1 offset-lg-2'>
                            <h2>Meter Points</h2></Col>
                    </Row>
                    <Row className='step'>
                        <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3 offset-xl-1 offset-lg-2'><h6>MPRN</h6></Col>
                        <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3'><h6>Post code</h6></Col>
                        <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3'><h6>Message</h6></Col>
                        {/*<Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3'><h6>Action</h6></Col>*/}
                    </Row>
                    {Object.values(mprns).map(mprn => {
                        const record = this.state.result[mprn];
                        return (
                            <div>
                                <hr/>
                                <Row className='step'>
                                    <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3 offset-xl-1 offset-lg-2'><Input
                                        value={record.mprn}/></Col>
                                    <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3'><Input
                                        value={record.address.postalCode}
                                        onChange={this.handlePostalCodeChange(record.mprn)}/></Col>

                                    <Col className='col-xl-2 col-lg-2 col-md-3 col-sm-3'></Col>
                                </Row>
                                {record.showAddress && <Row>
                                    <Col
                                        className='col-xl-5 col-lg-6 col-md-8 col-sm-12 offset-xl-1 offset-lg-2 step-body'>
                                        <FormGroup>
                                            <FindAddress
                                                name="supplyAddress"
                                                address={record.address}
                                                onChange={this.handleAddressChoice(record.mprn)}
                                            />
                                        </FormGroup>

                                    </Col>
                                </Row>
                                }</div>
                        )
                    }, this)}
                    <hr/><Row className='step'>
                        <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-12 step-header offset-xl-1 offset-lg-2'>
                            <Mutation mutation={START_NOMINATION}
                                      onCompleted={(data) => this.setState({step: "results", resultData: data})}>
                                {(start, {data}) => {
                                    return (<Button onClick={() => {
                                        const addresses = []
                                        for (const key in this.state.result) {
                                            if (this.state.result[key].address.postalCode) {
                                                addresses.push({
                                                    //...this.state.result[key].address,
                                                    city: this.state.result[key].mprn,
                                                    postalCode: this.state.result[key].address.postalCode,
                                                    mprn: this.state.result[key].mprn
                                                })
                                            }
                                        }
                                        start({
                                            variables: {
                                                addresses: addresses,
                                                annualQuantity: parseFloat(this.state.annualQuantity)
                                            }
                                        });
                                    }}>Start</Button>)
                                }}</Mutation>
                        </Col>
                    </Row>

                </div>;
            case "results" :
                return (<div>
                    <Row className='step'>
                        <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-12 step-header offset-xl-1 offset-lg-2'><h2>Nomination has
                            started...</h2>
                        </Col>
                    </Row>
                    <Row className='step'>
                        <Col className='col-xl-5 col-lg-6 col-md-8 col-sm-12 offset-xl-1 offset-lg-2'>
                            <Button onClick={() => this.setState({step: "enter-meter-points"})}>Enter more meter
                                points</Button>
                        </Col></Row>
                </div>)

                break
        }

    }
}

const LoadingComponent = () => <Loading/>
let withRouter2 = withRouter(BulkNomination);
export default (withRouter2); //compose()
